<template lang="pug">
  form(id="gobiz-form" v-if="payment !== null")
      div.md-form-group(:class="{'invalid':errors.has('name')}")
          input.md-input(
              type="text"
              name="name"
              v-model="payment.name"
              v-validate="'required'"
              data-vv-as="Name"
              :disabled="loading"
              ref="paymentName"
          )
          label Name
          span.form-error-msg(v-show="errors.has('name')") {{ errors.first('name') }}

      div.md-form-group(:class="{'invalid':errors.has('device_ip')}")
          input.md-input(
              type="text"
              name="device_ip"
              v-model="payment.meta.device_ip"
              v-validate="'required|ip'"
              maxlength="15"
              data-vv-as="IP Address"
              :disabled="loading"
          )
          label Device IP
          span.form-error-msg(v-show="errors.has('device_ip')") {{ errors.first('device_ip') }}
</template>

<script>
import FormMixin from '../form-mixin';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'GoBiz',
                type: 4,
                preset_amount: null,
                require_reference: true,
                require_drawer_kick: false,
                source: 'sunmi_gobiz',
                meta: {},
                outlets: [],
            }),
        },
    },

    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);

            return Object.assign(payment, {
                name: this.payment.name,
                type: 4,
                preset_amount: null,
                require_reference: true,
                require_drawer_kick: false,
                source: 'sunmi_gobiz',
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/gobiz-form.vue